export default "/kiban/_next/static/images/question_hover-b67db3bd99749fe1929dddf67d460ed2.png";